import React, { useState } from "react";
import { Map, Marker, ZoomControl, Overlay } from "pigeon-maps";
import {
  Box,
} from "@mui/material";
import { useUiStore } from "../stores/uiStore";
import PlaceOverlayCard from "./PlaceOverlayCard";

const LocationMapPigeon2 = ({
  places,
  onMarkerClick,
  center,
  createPlaceMode,
  onMapClick,
  height,
  width,
  favorites,
  showOverlayCard = true,
}) => {
  const hoveredPlaceId = useUiStore((state) => state.hoveredPlaceId);
  const mapCenter = useUiStore((state) => state.mapCenter);
  const selectedPlaceId = useUiStore((state) => state.selectedPlaceId);
  const setSelectedPlaceId = useUiStore((state) => state.setSelectedPlaceId);
  const setMapCenter = useUiStore((state) => state.setMapCenter);
  const [activeMarker, setActiveMarker] = useState(null);

  const handleMapClick = ({ latLng }) => {
    if (createPlaceMode) {
      const newMarker = {
        coordinates: {
          latitude: latLng[0],
          longitude: latLng[1],
        },
      };
      setActiveMarker(newMarker);
      if (onMarkerClick) {
        onMarkerClick(newMarker);
      }
      if (onMapClick) {
        onMapClick(newMarker.coordinates);
      }
    } else {
      // Close overlay when clicking map (outside card)
      setSelectedPlaceId(null);
      setActiveMarker(null);
    }
  };

  const handleMarkerClick = (place) => {
    setActiveMarker(place);
    if (!createPlaceMode) {
      // Handle both coordinate formats: coordinates object or latitude/longitude directly
      const coordinates = place.coordinates || 
        (place.latitude && place.longitude 
          ? { latitude: place.latitude, longitude: place.longitude }
          : null);
      
      // Recenter map on clicked pin
      if (coordinates) {
        setMapCenter([coordinates.latitude, coordinates.longitude]);
      }
      
      // Set selectedPlaceId to show overlay card instead of navigating
      setSelectedPlaceId(place._id);
      if (onMarkerClick) {
        onMarkerClick(place);
      }
      // REMOVED: navigate(`/places/${place._id}`);
    }
  };

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Map
        defaultCenter={[43.204, 27.91]}
        center={mapCenter || center || [43.204, 27.91]}
        defaultZoom={13}
        onClick={handleMapClick}
        height={height || "100%"}
        width={width || "100%"}
      >
            <ZoomControl />

            {places.map((place) => {
              const isHovered = hoveredPlaceId === place._id;
              // Handle both coordinate formats: coordinates object or latitude/longitude directly
              const coordinates = place.coordinates || 
                (place.latitude && place.longitude 
                  ? { latitude: place.latitude, longitude: place.longitude }
                  : null);
              
              if (!coordinates) return null;
              
              return (
                <Marker
                  key={place._id}
                  anchor={[
                    coordinates.latitude,
                    coordinates.longitude,
                  ]}
                  payload={place}
                  onClick={() => handleMarkerClick(place)}
                  color={isHovered ? "blue" : "red"}
                  width={isHovered ? 50 : 40}
                  height={isHovered ? 50 : 40}
                />
              );
            })}

            {activeMarker && (
              <Marker
                anchor={[
                  activeMarker.coordinates.latitude,
                  activeMarker.coordinates.longitude,
                ]}
                color={createPlaceMode ? "blue" : "red"}
                width={40}
                height={40}
              />
            )}

            {selectedPlaceId && !createPlaceMode && showOverlayCard && (() => {
              const selectedPlace = places.find(p => p._id === selectedPlaceId);
              if (!selectedPlace) return null;
              
              // Handle both coordinate formats: coordinates object or latitude/longitude directly
              const coordinates = selectedPlace.coordinates || 
                (selectedPlace.latitude && selectedPlace.longitude 
                  ? { latitude: selectedPlace.latitude, longitude: selectedPlace.longitude }
                  : null);
              
              if (!coordinates) return null;
              
              // Calculate offset to position card near marker (not covering it)
              // Position to the right of marker, closer above it for better visibility
              const offset = [-50, 150];
              
              return (
                <Overlay
                  key={selectedPlaceId}
                  anchor={[
                    coordinates.latitude,
                    coordinates.longitude,
                  ]}
                  offset={offset}
                >
                  <Box onClick={(e) => e.stopPropagation()}>
                    <PlaceOverlayCard
                      place={selectedPlace}
                      onClose={() => setSelectedPlaceId(null)}
                      favorites={favorites}
                    />
                  </Box>
                </Overlay>
              );
            })()}
      </Map>
    </Box>
  );
};

export default LocationMapPigeon2;
